// LEGACY: being replaced by components/designSystem/button. Do not restyle in place; new screens should use the design system.
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '@client/components/icons/icon/Icon';
import styles from './button.scss';

function Button({
  className,
  type = 'button',
  disabled,
  label,
  labelClassName,
  startIcon,
  endIcon,
  onClick,
  ...rest
}) {
  const iconLeft = startIcon && getIcon(startIcon);
  const iconRight = endIcon && getIcon(endIcon);

  return (
    <button
      className={classNames(styles.button, className)}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {iconLeft && iconLeft}
      {label && (
        <span
          className={classNames(
            iconLeft && styles.marginLeft,
            iconRight && styles.marginRight,
            labelClassName && labelClassName
          )}
        >
          {label}
        </span>
      )}
      {iconRight && iconRight}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelClassName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  startIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
  ]),
  endIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
  ]),
};

export default React.memo(Button);

function getIcon(PassedIcon) {
  return typeof PassedIcon === 'string' ? (
    <Icon iconClassName={PassedIcon} />
  ) : (
    PassedIcon
  );
}
